import { get, map } from 'lodash';
import { FaqCategoryQA } from './faq-category-qa';

interface IDeserializable {
  deserialize(input: any): this;
}

export class FaqCategory implements IDeserializable {
  id?: string;
  name?: string;
  isActive?: boolean;
  queries?: FaqCategoryQA[];

  deserialize(input: any): this {
    this.id = get(input, 'id');
    this.name = get(input, 'name');
    this.isActive = get(input, 'isActive');
    this.queries = this.buildQueries(get(input, 'queries', []));

    return this;
  }

  private buildQueries(input: any[]) {
    if (!input.length) return [];

    const tempQueries: FaqCategoryQA[] = map(input, (category) => {
      return new FaqCategoryQA().deserialize(category);
    });
    return tempQueries;
  }
}
